import { supabase } from './supabase';
import { MinerSpec } from './minerTypes';
import { miners } from './miners';
import { toast } from 'react-hot-toast';

export async function initializeCollections() {
  try {
    // Check if miners collection exists and has data
    const { data: existingMiners, error: checkError } = await supabase
      .from('miners')
      .select('count');

    if (checkError) throw checkError;

    // Only populate if collection is empty
    if (!existingMiners?.length) {
      const { error: insertError } = await supabase
        .from('miners')
        .insert(miners.map(miner => ({
          ...miner,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        })));

      if (insertError) throw insertError;
      toast.success('Database initialized successfully');
    }
  } catch (error: any) {
    console.error('Setup error:', error);
    toast.error('Failed to initialize database');
    throw error;
  }
}

export async function getAllMiners(): Promise<MinerSpec[]> {
  try {
    const { data, error } = await supabase
      .from('miners')
      .select('*')
      .order('release_year', { ascending: false });

    if (error) throw error;
    return data || miners; // Fallback to local data
  } catch (error) {
    console.error('Error getting miners:', error);
    return miners;
  }
}

export async function getMinerByModel(model: string): Promise<MinerSpec | null> {
  try {
    const { data, error } = await supabase
      .from('miners')
      .select('*')
      .eq('model', model)
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error getting miner:', error);
    return miners.find(m => m.model === model) || null;
  }
}

export async function getMinersByAlgorithm(algorithm: string): Promise<MinerSpec[]> {
  try {
    const { data, error } = await supabase
      .from('miners')
      .select('*')
      .eq('algorithm', algorithm);

    if (error) throw error;
    return data || miners.filter(m => m.algorithm === algorithm);
  } catch (error) {
    console.error('Error getting miners by algorithm:', error);
    return miners.filter(m => m.algorithm === algorithm);
  }
}

export async function getMinersByCoin(coin: string): Promise<MinerSpec[]> {
  try {
    const { data, error } = await supabase
      .from('miners')
      .select('*')
      .eq('coin', coin);

    if (error) throw error;
    return data || miners.filter(m => m.coin === coin);
  } catch (error) {
    console.error('Error getting miners by coin:', error);
    return miners.filter(m => m.coin === coin);
  }
}